import { useState } from "react";

export interface ModalType<T> {
  visible: boolean;
  selected: T | undefined;
  cloneMode?: boolean;
  disabled?: boolean;
}

export function useModalForm<T>() {
  const [modalForm, set] = useState<ModalType<T>>({
    visible: false,
    selected: undefined,
    cloneMode: false,
    disabled: true,
  });

  function add() {
    set({ visible: true, selected: undefined });
  }

  function edit(row: T) {
    set({ visible: true, selected: row });
  }

  function reset() {
    set({ visible: false, selected: undefined });
  }
  function clone(row: T) {
    set({ visible: true, selected: row, cloneMode: true });
  }

  return { modalForm, add, edit, reset, clone };
}
